/**
 * enum to represent channels web sdk api result
 */
export enum PromiseStatus {
  InitializeOk,
  InitializeInProgress,
  InitializeFailed,
  AgentProfileInitializeOk,
  AgentProfileInitiliazeFailed,
  AgentSdkInitializeOk,
  AgentSdkInitializeFailed,
  PresenceInitializeOk,
  PresenceInitializeFailed,
  AgentInitializeOk,
  AgentInitializeFailed,
  GetAvailabilityOk,
  GetAvailabilityFailed,
  PresenceUpdateOk,
  PresenceUpdateFailed
}

/**
 * enum for availability reason
 */
export enum AvailabilityReason {
  Away = 0,
  Break = 1,
  SystemIssues = 2,
  OutBoundCall = 3,
  AfterCallWork_CaseWellness = 4,
  NonBillableTraining_ABay = 5,
  BillableTraining = 6,
  Meeting_Coaching = 7,
  ProjectWork = 8,
  Lunch = 9,
  LogOut = 10,
  AtMax = 11,
  Unreachable = 12,
  PendingAcceptance = 13,
  NotAvailable = 14,
  ChatNotAccepted = 15,
  UnreachableByServer = 16,
  Available = 17,
  Busy = 18,

  // custom reason
  Unknown = -1
}

export class ChannelsConstants {
  public readonly availabilityReason: any;
  public readonly promiseStatus: any;
  public readonly webFormModality = "webform";
  public readonly chatModality = "chat";
  public readonly httpStatusCodeForbidden = 403;

  constructor() {
    this.availabilityReason = AvailabilityReason;
    this.promiseStatus = PromiseStatus;
  }
}
